/**
 * Better-Auth Client für das Frontend.
 * Wickelt Magic-Link-Login + Session-Handling.
 */
import { createAuthClient } from 'better-auth/react';
import { magicLinkClient } from 'better-auth/client/plugins';

const apiUrl = import.meta.env.VITE_API_URL ?? '';

export const authClient = createAuthClient({
  baseURL: apiUrl,
  plugins: [magicLinkClient()],
});

export const { signIn, signOut, useSession } = authClient;
